import { Link } from 'react-router-dom';
import { MarketingHeader } from '../../components/marketing/MarketingHeader';
import { MarketingFooter } from '../../components/marketing/MarketingFooter';
import { SEOHead } from '../../components/SEO/SEOHead';
import { StructuredData } from '../../components/SEO/StructuredData';
import { createOrganizationSchema, createBreadcrumbListSchema } from '../../components/SEO/StructuredData';

export const ContactPage = () => {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://simcarlo.com';

  return (
    <div className="marketing-page">
      <SEOHead
        metadata={{
          title: 'Contact Us - Get in Touch',
          description: 'Contact Simcarlo for support, sales inquiries, partnerships, or feedback. We respond within 24 hours during business days.',
          keywords: ['contact', 'support', 'help', 'customer service', 'get in touch'],
          ogImage: `${baseUrl}/images/Landing Main.png`,
          canonicalUrl: `${baseUrl}/contact`,
        }}
      />
      <StructuredData
        schemas={[
          createOrganizationSchema('Simcarlo', baseUrl, {
            email: 'hello@simcarlo.com',
            telephone: undefined,
          }),
          createBreadcrumbListSchema([
            { name: 'Home', url: baseUrl },
            { name: 'Contact', url: `${baseUrl}/contact` },
          ]),
        ]}
      />
      <MarketingHeader />

      {/* Hero Section */}
      <section className="marketing-hero">
        <div className="marketing-container">
          <div className="marketing-hero-content">
            <div className="marketing-hero-text">
              <h1 className="marketing-hero-title">Contact Us</h1>
              <p className="marketing-hero-subtitle">We're here to help. Get in touch with any questions or feedback.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Methods Section */}
      <section className="marketing-section">
        <div className="marketing-container">
          <div className="marketing-faq-grid">
            <div className="marketing-faq-item">
              <h3>General Inquiries</h3>
              <p>
                <a href="mailto:hello@simcarlo.com" style={{ color: 'var(--primary-color)' }}>
                  hello@simcarlo.com
                </a>
              </p>
              <p>For general questions, partnerships, or media inquiries.</p>
            </div>
            <div className="marketing-faq-item">
              <h3>Support</h3>
              <p>
                <a href="mailto:support@simcarlo.com" style={{ color: 'var(--primary-color)' }}>
                  support@simcarlo.com
                </a>
              </p>
              <p>Need help with your account or have a technical question? Our support team is here to help.</p>
            </div>
            <div className="marketing-faq-item">
              <h3>Sales</h3>
              <p>
                <a href="mailto:sales@simcarlo.com" style={{ color: 'var(--primary-color)' }}>
                  sales@simcarlo.com
                </a>
              </p>
              <p>Interested in enterprise plans, annual billing, or custom solutions? Let's talk.</p>
            </div>
            <div className="marketing-faq-item">
              <h3>Feedback</h3>
              <p>
                <a href="mailto:feedback@simcarlo.com" style={{ color: 'var(--primary-color)' }}>
                  feedback@simcarlo.com
                </a>
              </p>
              <p>Have ideas for new features or improvements? We'd love to hear from you.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Response Time Section */}
      <section className="marketing-section">
        <div className="marketing-container">
          <h2 className="marketing-section-title">Response Times</h2>
          <p className="marketing-section-description">
            We aim to respond to all inquiries within 24 hours during business days. 
            Support requests from Pro and Team plan users receive priority handling.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="marketing-faq-cta">
        <div className="marketing-container">
          <div className="marketing-cta-content">
            <h2 className="marketing-section-title">Ready to Get Started?</h2>
            <p className="marketing-section-description">Try Simcarlo free, no credit card required.</p>
            <div className="marketing-cta-buttons">
              <Link to="/signup" className="marketing-btn marketing-btn-primary marketing-btn-large">
                Sign Up Free
              </Link>
              <Link to="/pricing" className="marketing-btn marketing-btn-secondary marketing-btn-large">
                View Pricing
              </Link>
            </div>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
};

